import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './RegisterPage.css';
import 'react-phone-number-input/style.css';

import logo from '../../Media/Logo.png';
import Button from '../App/Common/Button/Button';
import * as Auth from '../../Utils/Auth';
import DateInput from '../Date/DateInput';
import PhoneInput from 'react-phone-number-input';
import ru from 'react-phone-number-input/locale/ru';

const formErrors = {
  username: "Некорректно заполнено поле 'Логин'",
  password: "Некорректно заполнено поле 'Пароль'",
  phone: "Некорректно заполнено поле 'Телефон'",
  mail: "Некорректно заполнено поле 'Email'",
  date_of_birth: "Некорректно заполнено поле 'Дата рождения'",
  name: "Некорректно заполнено поле 'ФИО ученика'",
  responsible_1_full_name: '',
  responsible_2_full_name: '',
  responsible_1_phone: "Некорректно заполнено поле 'Телефон' матери",
  responsible_2_phone: "Некорректно заполнено поле 'Телефон' отца",
  responsible_1_mail: "Некорректно заполнено поле 'Email' матери",
  responsible_2_mail: "Некорректно заполнено поле 'Email' отца",
  is_offer_accepted: 'Вы не приняли условия оферты',
};
function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
}

const RegisterPage = ({ logIn, isLoggedin }) => {
  const [registerData, setRegisterData] = useState({
    username: '',
    password: '',
    phone: '',
    mail: '',
    date_of_birth: '',
    name: '',
    responsible_1_full_name: '',
    responsible_2_full_name: '',
    responsible_1_phone: '',
    responsible_2_phone: '',
    responsible_1_mail: '',
    responsible_2_mail: '',
    is_offer_accepted: false,
  });
  const [message, setMessage] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedin) navigate('/', { replace: true });
  }, [isLoggedin]);

  const handleInputChange = (fieldName, fieldValue) => {
    let regData = registerData;
    regData[fieldName] = fieldValue;
    setRegisterData(regData);
  };

  const handleChangeFIO = (fieldName, event) => {
	let regData = registerData;
    const result = event.target.value.replace(/\d/g, '');
	event.target.value = result
	regData[fieldName] = result;
    setRegisterData(regData);
  };

  const handleRegisterAction = (registerData) => {
	let errorLines = [];
    if (registerData.password !== registerData.repassword) {
		errorLines.push(['Пароли не совпадают']);
    }
    if (
      !registerData.responsible_1_full_name &&
      !registerData.responsible_2_full_name
    ) {
		errorLines.push(['Укажите ФИО как минимум одного из родителей']);
      //return;
    }
    if (
      !registerData.responsible_1_phone &&
      !registerData.responsible_2_phone
    ) {
		errorLines.push(['Укажите телефон хотя бы одного из родителей']);
      //return;
    }
    if (!registerData.responsible_1_mail && !registerData.responsible_2_mail) {
		errorLines.push(['Укажите Email хотя бы одного из родителей']);
      //return;
    }
    Auth.register(registerData)
      .then((res) => {
        if (res.detail) {
          let json = JSON.parse(res.detail);
          
          Object.keys(json).forEach(function (key) {
            if (json[key][0].includes('занято')) {
              return errorLines.push(['Такой логин уже используется']);
            }
            errorLines.push(formErrors[key]);
          });
          setMessage(errorLines);
        } else if (res) {
          setMessage('');
          navigate('/', { replace: true });
          if (res.status === 400) {
            //console.log(res);
          }
          //setCookie('token', res.access, { maxAge: 60 * 60 * 1000 });
          //logIn(res.access, password);
        }
      })
      .catch((e) => {
        console.log(e);
        setMessage('Возникла ошибка');
      });
  };
  const currentDate = new Date();
  const fiveYearsDate = new Date(
    currentDate.getTime() - 1820 * 24 * 60 * 60 * 1000
  );
  const minDate = new Date(currentDate.getTime() - 18250 * 24 * 60 * 60 * 1000);
  return (
    <div className='registerPage__container'>
      <img src={logo} alt='logo' />
      <div className='registerPage__block'>
        <div className='registerPage__caption'>Данные ученика*</div>
        <input
          type='text'
          className='registerPage__input'
          placeholder={'Логин'}
          onChange={(e) => handleInputChange('username', e.target.value)}
        />
        <input
          type='password'
          className='registerPage__input'
          placeholder={'Пароль'}
          onChange={(e) => handleInputChange('password', e.target.value)}
        />
        <input
          type='password'
          className='registerPage__input'
          placeholder={'Подтверждение пароля'}
          onChange={(e) => handleInputChange('repassword', e.target.value)}
        />
        <input
          type='text'
        
          className='registerPage__input'
          placeholder={'ФИО'}
          onChange={(e) => handleChangeFIO('name', e)}
        />
        <input
          type='text'
          className='registerPage__input'
          placeholder={'Email'}
          onChange={(e) => handleInputChange('mail', e.target.value)}
        />

        <PhoneInput
          className='registerPage__input'
          placeholder='Телефон'
          labels={ru}
          onChange={(value) => handleInputChange('phone', value)}
        />
        <DateInput
          date={formatDate(fiveYearsDate)}
          minDate={formatDate(minDate)}
          maxDate={formatDate(fiveYearsDate)}
          onChangeAction={(e, idx) =>
            handleInputChange('date_of_birth', formatDate(e))
          }
        />
      </div>
      <div className='registerPage__block'>
        <div className='registerPage__caption'>Данные матери</div>
        <input
          type='text'
          className='registerPage__input'
          placeholder={'ФИО'}
          onChange={(e) =>
            handleChangeFIO('responsible_1_full_name', e)
          }
        />
        <input
          type='text'
          className='registerPage__input'
          placeholder={'Телефон/Telegram'}
          onChange={(e) =>
            handleInputChange('responsible_1_phone', e.target.value)
          }
        />
        <input
          type='text'
          className='registerPage__input'
          placeholder={'E-mail'}
          onChange={(e) =>
            handleInputChange('responsible_1_mail', e.target.value)
          }
        />
      </div>
      <div className='registerPage__block'>
        <div className='registerPage__caption'>Данные отца</div>
        <input
          type='text'
          className='registerPage__input'
          placeholder={'ФИО'}
          onChange={(e) =>
            handleChangeFIO('responsible_2_full_name', e)
          }
        />
        <input
          type='text'
          className='registerPage__input'
          placeholder={'Телефон/Telegram'}
          onChange={(e) =>
            handleInputChange('responsible_2_phone', e.target.value)
          }
        />
        <input
          type='text'
          className='registerPage__input'
          placeholder={'E-mail'}
          onChange={(e) =>
            handleInputChange('responsible_2_mail', e.target.value)
          }
        />
      </div>
      <div>
        <input
          type='checkbox'
          className='registerPage__cb'
          id='offert'
          onChange={(e) =>
            handleInputChange('is_offer_accepted', e.target.checked)
          }
        />
        <label for='offert'>Согласен с условиями офферты</label>
      </div>
      {message.length > 0
        ? message.map((mess, i) => {
            return <div className='error-message'>{mess}</div>;
          })
        : ''}
      <Button
        buttonText={'Зарегистрироваться'}
        onClickAction={() => handleRegisterAction(registerData)}
        color={'#7A5AF8'}
        type={'filled'}
      />
    </div>
  );
};
export default RegisterPage;
